import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=d3c9ac38&"
import script from "./BaseMenu.vue?vue&type=script&lang=js&"
export * from "./BaseMenu.vue?vue&type=script&lang=js&"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BaseMenu.vue"
export default component.exports